import { zodValidator, type TypedFetch } from "@spiriidk/utils";

import {
  AuthzContextResponseSchema,
  type AuthzContextResponse,
} from "../../schemas/authz-context";

async function getAuthzContext(
  fetch: TypedFetch,
  signal?: AbortSignal
): Promise<AuthzContextResponse> {
  return fetch("/admin/authz/context", {
    validateResponse: zodValidator(AuthzContextResponseSchema),
    signal,
  });
}

export { getAuthzContext };
